"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionType = void 0;
/*
 Copied from portis: packages/portis-crypto/src/enums/encryptionType.ts
 */
var EncryptionType;
(function (EncryptionType) {
    EncryptionType[EncryptionType["AesCbc256_HmacSha256_B64"] = 2] = "AesCbc256_HmacSha256_B64";
})(EncryptionType || (exports.EncryptionType = EncryptionType = {}));
//# sourceMappingURL=encryptionType.js.map